import {
  getGTMElementName,
} from '@tracking/components/utils';

export function focusHandler(event) {
  if (event?.target) {
    const element = getGTMElementName(event.target);
    if (!element) {
      return;
    }
    const parentForm = event.target.closest('form');
    const formId = parentForm?.id;
    window.GTMtracker.trackEvent('focusFormatter', {
      element,
      formId,
    });
  }
}
